export default {
    tab_title: 'Cash Club Offers',
    sub_title: 'Cash Club Offers Filter',
    list_title: 'Cash Club Offers List',
    filters: {
        partner: 'Partner',
        campaign_status: 'Campaign Status',
        campaign_status_active: 'Active',
        campaign_status_expired: 'Expired',
        campaign_status_not_set: 'Unassigned',
    },
    table: {
        image: 'Image',
        name: 'Offer Name',
        value: 'Value',
        category: 'Category',
        sync: 'Synchronization',
        url: 'Offer Link',
        brand: 'Brand',
        campaign: 'Campaign',
    },
    edit_page: {
        edit_title: 'Edit Cash Club Offer',
        offer_name: 'Offer Name',
        partner: 'Partner',
        brand: 'Brand',
        campaign: 'Campaign',
        campaign_code: 'Campaign Code',
        discount_percentage: 'Discount Percentage',
        start_from: 'Start Date',
        end_from: 'End Date',
        description: 'Offer Description',
        instructions: 'Offer Instructions',
    }
}